<template>
  <div class="wrap" :class="{'themeHuttons': brokeName==='Huttons','themeEcoprop': brokeName==='ECOPROP'}">
    <van-sticky>
      <van-nav-bar
        class="defaultNav"
        title="NEARBY AMENITIES"
        left-text
        left-arrow
        ref="mtHeader"
        @click-left="back()"
      />
    </van-sticky>
    <div class="content">
      <div class="nearby-list-box" v-for="(item, index) in nearbyList" :key="index">
        <p class="nearby-list-name"><span class="nearby-list-mark"></span><span class="nearby-list-text">{{item.type==='subway_station'?'Mrt Station': $capitalizeAndRemoveUnderscore(item.type)}}</span></p>
        <ul class="nearby-list">
          <li class="nearby-item" v-for="(sitem, sindex) in item.value" :key="sindex">
            <span>{{sitem && sitem.name?sitem.name:''}}</span>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'nearbyAmenities',
  data(){
    return {

    }
  },
  props: {
    nearbyList: {
      type: Array,
      default: []
    },
    brokeName: 'ECOPROP'
  },
  mounted(){
    console.log('this.nearbyList', this.nearbyList)
  },
  methods: {
    back(){
      this.$emit('hideDetail', 'showNearby')
    }
  }

}
</script>

<style lang='less' scoped>
.themeHuttons{
  .theme(#041E42,#041E42);
}
.themeEcoprop{
  .theme(#00D2C8,#00D2C8);
}
.theme(@backcolor:#00D2C8,@fcolor:#00D2C8){
  .content{
    padding: 0.1rem 0.2rem;
    .nearby-list-box{
      .nearby-list-name{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .nearby-list-mark{
          display: inline-block;
          width: 14px;
          height: 14px;
          background: @backcolor;
          border-radius: 1px;
          margin-right: 5px;
        }
        .nearby-list-text{
          font-size: 0.12rem;
          font-weight: 600;
        }
      }
      .nearby-list{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .nearby-item{
          padding-right: 0.3rem;
          margin-bottom: 0.2rem;
          font-size: 0.12rem;
          font-family: Montserrat-Medium, Montserrat;
          font-weight: 500;
          color: #333333;
          line-height: 19px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/shareMobile/nearbyAmenities.vue